// extracted by mini-css-extract-plugin
module.exports = {"emissionFactorInput":"styles_emissionFactorInput__3JsM9","input":"styles_input__25Qmj","error":"styles_error__3JDq6"};